import React, { useContext, useLayoutEffect } from "react";
import { HttpFactory } from "../RequestHandler";
import portalContext from "../context/contexts/portal-context";
import StorageUtils from "@/utility/StorageUtils";
import { isSupportWidgetRoute } from "../constants/supportWidgetRoutes";
import { isMessengerOpen } from "../components/Support/zendeskMessengerState";

export const withAuthentication = (Component) => (props) => {
  const context = useContext(portalContext);

  useLayoutEffect(() => {
    const onSupportRoute = isSupportWidgetRoute(window.location.pathname);

    if (!onSupportRoute) {
      // Neither our launcher nor Zendesk's own UI belongs here — collapse
      // any lingering open conversation. close(), not hide(): hide() "hides
      // all parts of the widget from the page" and also swallows our own
      // zE("messenger","open") calls afterward (see zendeskHandoff.js) —
      // close() just collapses an open conversation and doesn't disable
      // future opens, the same assumption Pricing/Subscription.js's
      // pre-existing open()/close() toggle already relies on.
      window.zE?.("messenger", "close");
    }

    // Zendesk's own default launcher/chrome stays hidden via CSS while our
    // assistant is the front door — but NOT while a conversation is
    // actually open, so its native minimize/close control stays usable to
    // dismiss it (otherwise there'd be no way to close an open conversation
    // at all, since our own launcher only opens things). Targets the
    // launcher iframe by its title, same as the dead code below did before
    // it was swapped for the (broken, whole-widget) zE("messenger","hide") call.
    const zendeskLauncher = document.querySelector("iframe[title*='Button to launch messaging window']");
    if (zendeskLauncher) {
      const shouldShow = onSupportRoute && isMessengerOpen();
      zendeskLauncher.parentElement.style.display = shouldShow ? "" : "none";
    }
  });

  const shopId = context.selectedShop;
  const shop = (context.storesData || []).find(({ _id }) => _id == shopId);

  const token = {
    token_type: "bearer",
    expires_in: 300,
    access_token: null,
    refresh_token: null,
  };

  const requestClient = HttpFactory.getInstance();
  requestClient.setToken(StorageUtils.getToken() || token);
  return <Component {...props} user={context} loggedInShop={shopId ? shop : {}} httpClient={requestClient} />;
};
